import { render, staticRenderFns } from "./AddEditPriorityZone.vue?vue&type=template&id=99749a54"
import script from "./AddEditPriorityZone.vue?vue&type=script&lang=js"
export * from "./AddEditPriorityZone.vue?vue&type=script&lang=js"
import style0 from "./AddEditPriorityZone.vue?vue&type=style&index=0&id=99749a54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports